import React from 'react';
import UserDetailsChangeLogsCard from './components/UserDetailChangeLogsIndex.jsx';

const UserDetailsChangeLogs = ({program}) => {
  return (
        <UserDetailsChangeLogsCard program={program}/>
)}

export default UserDetailsChangeLogs;
